<template>
  <div class="def-lang">
    <div class="def-lang__front" :class="{ 'def-lang__front_active': open }" @click="open = !open">
      {{ getCurrentLang }}
      <svg>
        <use xlink:href="#svg-arrow-down"></use>
      </svg>
    </div>

    <transition name="fade">
      <div v-if="open" class="def-lang__items">
        <a
          v-for="item in siteLanguages"
          :href="item.link"
          :class="{ 'def-lang__item_active': item.current }"
          class="def-lang__item"
          >{{ item.name }}</a
        >
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DefLang',
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapState({
      siteLanguages: ({ results }) => results.siteLanguages.langs,
    }),
    getCurrentLang() {
      try {
        const currentKey = Object.keys(this.siteLanguages).filter(
          (el) => this.siteLanguages[el].current
        );
        return this.siteLanguages[currentKey].name;
      } catch (err) {
        console.error('problem with search active lang :', err);
        return '';
      }
    },
  },
  watch: {
    open(prevValue) {
      if (prevValue) {
        document.addEventListener('click', this.handlerAnotherClick);
      } else {
        document.removeEventListener('click', this.handlerAnotherClick);
      }
    },
  },
  methods: {
    handlerAnotherClick({ target }) {
      if (!target.closest('.def-lang')) {
        this.open = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-lang {
  font-weight: 500;
  font-size: rem(14);
  line-height: 100%;
  color: var(--text-colour-primary);
  text-transform: uppercase;
  position: relative;
  &__front {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.2s linear color;
    &:hover {
      color: var(--text-colour-secondary);
      svg {
        fill: var(--text-colour-secondary);
      }
    }

    svg {
      width: 18px;
      height: 18px;
      transition: 0.3s linear transform, 0.2s linear fill;
      margin-left: 5px;
      fill: var(--text-colour-primary);

      transform: translateY(-2px);
    }

    &_active {
      svg {
        transform: rotate(190deg);
      }
    }
  }

  &__items {
    display: flex;
    flex-direction: column;
    padding: 0 13px;
    position: absolute;
    background-color: #fff;
    z-index: 1;
    right: 0;
  }

  &__item {
    margin-top: 16px;
    white-space: nowrap;
    transition: 0.2s linear text-decoration-color;
    text-decoration: underline;
    text-decoration-color: transparent;
    text-underline-position: under;
    &:hover {
      text-decoration-color: currentColor;
      //color: var(--text-colour-secondary);
      //background-color: var(--background-grey);
    }
    &:last-child {
      margin-bottom: 10px;
    }

    &_active {
      color: var(--text-colour-secondary);

      &:hover {
        color: var(--text-colour-secondary);
      }
    }
  }
}
</style>
